import React, { useState } from "react";
import { Button } from "../../components/ButtonUtils";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { ImageKitUpload } from "../../../ui/ImageKitLibrary";
import { defaultImage } from "../../../lib/libraries/imageKit/ImageKit";

const ExteriorImages = ({ showModal, onClick, exteriorImages, setExteriorImages }) => {
  return (
    <div className={showModal ? "fixed inset-0 z-[9999] flex items-center justify-center p-4" : "hidden"}>
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClick}></div>
      <div role="dialog" aria-modal="true" className="relative w-full max-w-5xl bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden">
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200">
          <h2 className="text-lg font-semibold">Add Interior / Exterior Images</h2>
          <button type="button" onClick={onClick} className="inline-flex items-center justify-center h-8 w-8 rounded-full hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500">
            <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path>
            </svg>
            <span className="sr-only">Close</span>
          </button>
        </div>
        <div className="p-4 overflow-y-auto max-h-[70vh]">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {exteriorImages?.map((m, key) => (
              <ImageWidget key={key} index={key} menu={exteriorImages} setMenu={setExteriorImages} />
            ))}
          </div>
          <div className="mt-6 flex flex-wrap gap-3 justify-between">
            <Button
              props={{
                type: "button",
                title: "Click To Add Image",
                category: "orange",
                action: "add",
                onClick: () => {
                  setExteriorImages([...(exteriorImages || []), { thumbnail: null, image_cdn_id: null }]);
                },
              }}
            />
            <Button
              props={{
                type: "button",
                title: "Finish",
                category: "default",
                action: "default",
                onClick: () => onClick(),
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExteriorImages;

const removeExtImage = ({ menu, setMenu, index }) => {
  const data = menu?.filter((_, i) => i !== index);
  setMenu([...(data || [])]);
};

const ImageWidget = ({ index, setMenu, menu }) => {
  const [thumbnail, setThumbnail] = useState(menu[index]?.thumbnail ? menu[index]?.thumbnail : null);
  const [thumbnailId, setThumbnailId] = useState(menu[index]?.image_cdn_id ? menu[index]?.image_cdn_id : null);

  return (
    <div className="rounded-2xl border border-gray-200 p-4 bg-white shadow-sm">
      <div className="flex items-start justify-between gap-3 mb-3">
        <p className="text-sm font-semibold text-gray-700">Ext. Image No.{index + 1}</p>
        <Button
          props={{
            type: "button",
            title: `Click To Remove image No.${index + 1}`,
            category: "red",
            action: "",
            onClick: () => {
              removeExtImage({ setMenu, menu, index: index });
            },
          }}
        />
      </div>
      <ImageKitUpload
        thumbnail={thumbnail || defaultImage}
        thumbnailId={thumbnailId}
        setThumbnail={setThumbnail}
        setThumbnailId={setThumbnailId}
        folder={image_kit_folder("dosee/", FOLDERS.HOTELS)}
        isRestaurantModal={true}
        onSuccess={(url, id) => {
          const dt = menu.map((x) => x);
          dt[index] = { thumbnail: url, image_cdn_id: id };
          setMenu(dt);
        }}
      />
    </div>
  );
};
